import { Fragment } from "react"
import { ModalidadGrupoTarifa } from "src/gql/schema"
import DetailRow from "src/shared/components/data-display/Detail/kit/DetailRow/DetailRow"
import DetailText from "src/shared/components/data-display/Detail/kit/DetailText/DetailText"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { capitalize } from "src/shared/helpers/capitalize"
import { ExtraTarifaAgrupada } from "src/shared/helpers/groupExtrasTarifasByTarifa"

type Props = {
    grupos: ExtraTarifaAgrupada[]
}

const EntradaHospedajeMotel = ({ grupos }: Props) => (
    <>
        {grupos.map((grupo, gIdx) => (
            <Fragment key={`extra-grupo-motel-${gIdx}`}>
                <DetailRow>
                    {grupo.tarifa?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base
                        ? <DetailText type='bold'>{capitalize(grupo.tarifa.grupo_tarifa.modalidad)}</DetailText>
                        : <DetailText type='bold'>{capitalize(grupo.tarifa?.grupo_tarifa?.modalidad || "")} - {grupo.tarifa?.grupo_tarifa?.nombre || ""}</DetailText>
                    }
                </DetailRow>
                {grupo.entradas.map((entry, eIdx) => (
                    <DetailRow key={`extra-entry-motel-${eIdx}`}>
                        <DetailText style={{ maxWidth: "170px" }}>
                            1 hospedaje extra - {formatCurrencyToFixed(entry.subtotales?.precio_unitario || 0)}
                        </DetailText>
                        <DetailText type="bold" textAlign="right" style={{ maxWidth: "90px" }}>
                            {formatCurrencyToFixed(entry.subtotales?.total || 0)}
                        </DetailText>
                    </DetailRow>
                ))}
            </Fragment>
        ))}
    </>
)

export default EntradaHospedajeMotel
